import { AI_POLICY_URL, GLOPLA_PARTICIPANT_HOST } from '@/constant';
import { type FragmentType, useFragment } from '@/gql/codegen';
import { graphql } from '@/gql/codegen/gql';
import { TermsOfUseAgreementStateEnum } from '@/gql/codegen/graphql';
import { Button } from '@/routes/_embaUserLayout/-components/Button';
import type React from 'react';
import styles from './index.module.scss';

export const TERMS_OF_USE_ITEM = graphql(/* GraphQL */ `
  fragment TemsOfUseItem on TermsOfUse {
    id
    agreementState
  }
`);

export type TermsOfServicePageProps = {
  termsOfUseData: FragmentType<typeof TERMS_OF_USE_ITEM>;
  onAgreeTerms: () => Promise<void>;
  agreeTermsMutationLoading: boolean;
};

export const TermsOfServicePage = ({
  termsOfUseData,
  onAgreeTerms,
  agreeTermsMutationLoading,
}: TermsOfServicePageProps) => {
  const termsOfUse = useFragment(TERMS_OF_USE_ITEM, termsOfUseData);
  const termsUrl = `${GLOPLA_PARTICIPANT_HOST}/term/8`;

  return (
    <div className={styles.termsOfServicePage}>
      <div className={styles.termsOfServicePageInner}>
        <h2 className={styles.termsOfServicePageTitle}>利用規約</h2>
        {termsOfUse.agreementState ===
          TermsOfUseAgreementStateEnum.NotAgreed && (
          <p className={styles.termsOfServicePageDescription}>
            サービスのご利用にあたり、利用規約への同意が必要です。利用規約に同意いただけない場合はサービスはご利用いただけません。
          </p>
        )}
        {termsOfUse.agreementState ===
          TermsOfUseAgreementStateEnum.TermsUpdated && (
          <p className={styles.termsOfServicePageDescription}>
            利用規約を更新しました。サービスのご利用にあたり、利用規約への同意が必要です。利用規約に同意いただけない場合はサービスはご利用いただけません。
          </p>
        )}

        <p className={styles.termsOfServicePageExternalLink}>
          <a href={termsUrl} target="_blank" rel="noreferrer">
            利用規約の確認はこちら
          </a>
        </p>

        <p className={styles.aiPolicyNote}>
          ※本同意には、当社 GLOBIS 学び放題・GLOBIS Unlimited・eMBA 共通の
          <a href={AI_POLICY_URL} target="_blank" rel="noreferrer">
            AIポリシー
          </a>
          の承認が含まれ、利用規約等と一体となって適用されます。
        </p>

        <div className={styles.termsOfServicePageActionArea}>
          <Button onClick={onAgreeTerms} disabled={agreeTermsMutationLoading}>
            利用規約に同意し、サービスを利用する
          </Button>
        </div>
      </div>
    </div>
  );
};
